module.exports = __webpack_public_path__ + "img/approver.4b8e5b0b.svg";